import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from "axios";
const BASE_URL = process.env.REACT_APP_SERVER_URL || "";
const AUTH_HEADER = "Authorization";
const CORS_HEADER = "Access-Control-Allow-Origin";

// console.log("BASE_URL: ", BASE_URL);
// Create axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // Optional: Add timeout for requests
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420"
  }
});

// Utility: Get access token from storage
const getAccessToken = (): string | null =>
  sessionStorage.getItem("accessToken");

// Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const accessToken = getAccessToken();

    // Add Authorization header for secure methods
    if (
      ["POST", "PUT", "DELETE"].includes(config.method?.toUpperCase() || "")
    ) {
      if (accessToken) {
        config.headers.set(AUTH_HEADER, `Bearer ${accessToken}`);
      }
    }

    // Allow CORS
    config.headers.set(CORS_HEADER, "*");

    return config;
  },
  (error: AxiosError) => {
    console.error("Request error: ", error.message); // Log request error
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // Optional: Log successful responses
    // console.log(
    //   `[${response.config.method?.toUpperCase()}] ${response.config.url}: `,
    //   response.data
    // );
    return response;
  },
  async (error: AxiosError) => {
    if (error.response) {
      const status = error.response.status;

      // Handle specific status codes
      switch (status) {
        case 401:
          console.error(
            "Unauthorized! Consider refreshing token or redirecting to login."
          );
          // Optional: Add logic for refreshing tokens or handling 401 errors
          break;
        case 403:
          console.error("Forbidden! You do not have access to this resource.");
          break;
        case 404:
          console.error("Resource not found!");
          break;
        case 500:
          console.error("Server error! Please try again later.");
          break;
        default:
          console.error(
            `Error ${status}: ${
              (error.response.data as any)?.message || error.message
            }`
          );
      }
    } else if (error.request) {
      console.error("No response received from server: ", error.message);
    } else {
      console.error("Unexpected error: ", error.message);
    }

    // Return a rejected promise to propagate the error to the caller
    return Promise.reject(error);
  }
);

export default axiosInstance;
